/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserBookingsListResponse } from '../../models/user-bookings-list-response';

export interface BookingControllerUserBookings$Params {
  from_date?: string;
  to_date?: string;
  identifier?: string;
  query?: string;
  user?: string;
  status_id?: number;
  limit: number;
  skip: number;
  user_id: number;
}

export function bookingControllerUserBookings(http: HttpClient, rootUrl: string, params: BookingControllerUserBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserBookingsListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerUserBookings.PATH, 'get');
  if (params) {
    rb.query('from_date', params.from_date, {});
    rb.query('to_date', params.to_date, {});
    rb.query('identifier', params.identifier, {});
    rb.query('query', params.query, {});
    rb.query('user', params.user, {});
    rb.query('status_id', params.status_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.path('user_id', params.user_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserBookingsListResponse;
      }>;
    })
  );
}

bookingControllerUserBookings.PATH = '/booking/user/{user_id}';
